<div [formGroup]="form" [ngSwitch]="field.controlType" aria-label="dynamic-form-container">

  <label *ngIf="field.key !== '' " [attr.for]="field.key" class="font-medium text-700 text-xs mb-2 block uppercase" aria-label="field-label-{{field.key}}">{{field.label | translate}}
  </label>

  <input *ngSwitchCase="'textbox'" class="p-inputtext w-full text-sm" [formControlName]="field.key" [type]="field.type" 
    [attr.aria-label]="getAriaLabel(field.label, 'input')">

  <input *ngSwitchCase="'hiddenfield'" type="hidden" [formControlName]="field.key">

  <p-select [options]="field.options" *ngSwitchCase="'dropdown'" [formControlName]="field.key" optionLabel="key"
    optionValue="value" filterBy="key" styleClass="w-full text-sm"
    placeholder="{{'REPORTS.REPORT_TEMPLATE.SELECT_PLACEHOLDER' | translate}}"
    [attr.aria-label]="getAriaLabel(field.label, 'dropdown')">
    <ng-template let-option pTemplate="item">
      <div class="text-sm">{{option.key}}</div>
    </ng-template>
  </p-select>

  <p-multiSelect [options]="field.options" *ngSwitchCase="'multiselect'" [formControlName]="field.key" optionLabel="key"
    optionValue="value" filterBy="key" styleClass="w-full text-sm"
    placeholder="{{'REPORTS.REPORT_TEMPLATE.SELECT_PLACEHOLDER' | translate}}"
    [attr.aria-label]="getAriaLabel(field.label, 'multiselect')">
    <ng-template let-option pTemplate="item">
      <div class="text-sm">{{option.key}}</div>
    </ng-template>
  </p-multiSelect>

  <p-select *ngSwitchCase="'timeperioddropdown'" [options]="field.options" [formControlName]="field.key"
    optionLabel="label" styleClass="w-full text-sm" (onChange)="SelectTimePeriod($event,form)"
    placeholder="{{'REPORTS.REPORT_TEMPLATE.SELECT_PLACEHOLDER' | translate}}"
    [attr.aria-label]="getAriaLabel(field.label, 'dropdown')">

    <ng-template pTemplate="selectedItem">
      <div *ngIf="selectedRelativeDate">
        <div *ngIf="timePeriodDate; else customDate">
          <div class="text-sm" *ngIf="timePeriodDate !== null">{{timePeriodDate[0] | date: 'MM/dd/yyyy'}} -
            {{timePeriodDate[1] | date: 'MM/dd/yyyy'}}</div>
        </div>

        <ng-template #customDate>
          <div class="text-sm flex align-items-center justify-content-between">
            {{selectedTimePeriod.label}}
            <span class="text-500">{{selectedTimePeriod.date['from_date'] | date: 'mediumDate'}}</span>
          </div>
        </ng-template>
      </div>
    </ng-template>

    <ng-template let-time pTemplate="item">
      <div *ngIf="time.value === 99; else customDateOne">
        <div (click)="customDateModal.next(true)" class="text-sm" data-testid="custom-date-option">{{time.label}}</div>
      </div>

      <ng-template #customDateOne>
        <div class="text-sm flex align-items-center justify-content-between">
          {{time.label}}
          <span class="text-500">{{time.date['from_date'] | date: 'mediumDate'}}</span>
        </div>
      </ng-template>
    </ng-template>
  </p-select>

  <div *ngSwitchCase="'timeperioddropdown'">
    <p-message *ngIf="moreThanThreeMonths" severity="error" aria-label="error-message">
      <div class="-m-2 flex align-items-center">
          <i class="fa fa-exclamation-triangle mr-2 p-error" aria-label="warning-icon"></i>
          <span class="custom-message p-error text-xs">{{'REPORTS.REPORT_TEMPLATE.FILTER_INFO_1' | translate}}
            <strong>
              <a href="javascript:void(0)" (click)="OpenLongerReport()" class="p-error" 
                data-testid="open-longer-report-link" aria-label="open-longer-report">
                {{'REPORTS.REPORT_TEMPLATE.CLICK_HERE' | translate}}
              </a>
            </strong>
            {{'REPORTS.REPORT_TEMPLATE.FILTER_INFO_2' | translate}}
          </span>
        </div>
    </p-message>
  </div>

  <p-toggleSwitch *ngSwitchCase="'inputswitch'" [formControlName]="field.key" 
    [attr.aria-label]="getAriaLabel(field.label, 'switch')"></p-toggleSwitch>

  <p-datepicker *ngSwitchCase="'datepicker'"
  inputId="calendar-timeonly" 
  styleClass="w-full"
  inputstyleClass="text-sm m-0 border-400 h-2rem border-round"
  [formControlName]="field.key"
  [hourFormat]="12"
  [placeholder]="'Shared.TASK.TASK-CREATE.PLACEHOLDER_SELECT_DATE' | translate"
  aria-label="start-time-calendar"
  [min]="minimumDate"
   />

  <app-error-msg *ngIf="GetField(form,field.key).touched && GetField(form,field.key).invalid"
    [errors]="GetField(form,field.key).errors" [fieldLabel]="field.label">
  </app-error-msg>

</div>

<app-datepicker *ngIf="customDateModal | async as showPopup" [visible]="showPopup" [form]="form"
  [dateRange]="timePeriodDate" (selectedDate)="onDateSelect($event,form)"
  (hideCalender)="hideCalender($event)" aria-label="custom-date-picker">
</app-datepicker>